import { useEffect, useState } from 'react';

export function useValidateChatInput({ input }: { input: string }) {
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (input.length > 500) {
      return setError('El mensaje no puede superar los 500 caracteres');
    }
    setError(null);
  }, [input]);

  return { error, setError };
}
